import Icon from 'src/components/ui/Icon.vue'
import CustomModal from 'src/core/components/customModal/CustomModal.vue'

export default ({ app }) => {
  // eslint-disable-next-line vue/multi-word-component-names
  app.component('Icon', Icon)
  app.component('CustomModal', CustomModal)
}
